<template>
  <div class="chart-wrapper">
    <apexchart
      :type="'pie'"
      :series="series"
      :options="chartOptions"
      :height="chartHeight"
    ></apexchart>
  </div>
</template>

<script>
export default {
  props: {
    data: { type: Array, default: () => [] },
    labels: { type: Array, default: () => [] },
    title: { type: String, default: '' },
    hideLegend: { type: Boolean, default: false }
  },

  data() {
    return {
      series: this.data,
      chartOptions: {
        chart: {
          type: 'pie',
          width: '100%'
        },
        colors: [
          '#758dd3','#e4c278','#a7acd2','#e2c581',
          '#dad0cf','#dbcfb5','#cad1c9','#bdcede'
        ],
        labels: this.labels,
        legend: { show: !this.hideLegend, position: 'right' },
        responsive: [
          {
            breakpoint: 1024, // tablets & small laptops
            options: {
              chart: { width: '100%' },
              legend: { position: 'bottom', fontSize: '12px' }
            }
          },
          {
            breakpoint: 768, // mobile
            options: {
              chart: { width: 260 },
              legend: { position: 'bottom', fontSize: '10px' }
            }
          },
          {
            breakpoint: 480,
            options: {
              chart: { width: 200 },
              legend: { position: 'bottom', fontSize: '9px' }
            }
          }
        ]
      }
    };
  },

  computed: {
    chartHeight() {
      // reduce height if legend is hidden
      return this.hideLegend ? 250 : 300;
    }
  }
};
</script>

<style scoped>
.chart-wrapper {
  width: 100%;
  max-width: 100%;
  overflow-x: auto; /* horizontal scroll if needed */
}
</style>
